import { ExtendedConstructionNumber, showPrice } from '@bpd-library/utilities';
import { isGermany } from '@utilities/is-germany';

import { translateItem } from '../hooks';

const NHG_LIMIT_KEY = 'NHGLimit';
const NGH_ECO_LIMIT_KEY = 'NHGEcoLimit';
const EXCLUDED_HOUSE_TYPES = ['Kavel', 'Parkeerplaats', 'Bedrijfsunit'];

const translateNhgLimit = async () => parseInt(await translateItem(NHG_LIMIT_KEY));
const translateNhgEcoLimit = async () => parseInt(await translateItem(NGH_ECO_LIMIT_KEY));

const nhgChecker = () => {
    let nhgLimit: number;
    let nhgEcoLimit: number;

    const init = async () => {
        nhgLimit = await translateNhgLimit();
        nhgEcoLimit = await translateNhgEcoLimit();
    };

    const isNhg = (amount: number, options?: { ecoLimit?: boolean }) => {
        if (options?.ecoLimit) return amount < nhgEcoLimit;
        return amount <= nhgLimit;
    };

    const isConstructionNumberNhg = (constructionNumber: ExtendedConstructionNumber) => {
        if (isGermany() || !showPrice({ constructionNumber })) return false;

        const { salesPrice, propertyType } = constructionNumber;
        if (!propertyType?.houseType || EXCLUDED_HOUSE_TYPES.includes(propertyType.houseType)) {
            return false;
        }

        const price = salesPrice?.amount?.from;
        const showNHG = !!price && isNhg(price, { ecoLimit: constructionNumber.isEnergyNeutral });
        return showNHG;
    };

    init();

    return { isConstructionNumberNhg };
};

const { isConstructionNumberNhg } = nhgChecker();

export { isConstructionNumberNhg };
